import MonthViewDayAgendaCallout from './MonthViewDayAgendaCallout';
import useMonthViewViewState from '../hooks/useMonthViewViewState';
import { CalendarViewBaseProps, CalendarViewType } from '../schema';
import { WeeklyDayPicker, AnimationDirection } from '@fluentui/react';
import { observer } from 'mobx-react-lite';
import { getCalendarStrings } from 'owa-datepicker-common';
import { asDate, dateTimeFormatter } from 'owa-datetime';
import { observableToday } from 'owa-observable-datetime';
import { getPalette } from 'owa-theme';
import * as React from 'react';
import ExpandableDatePicker from './ExpandableDatePicker';

import * as styles from './MonthView.scss';
import classNames from 'classnames';

export interface MonthViewProps extends CalendarViewBaseProps {
    selectedDate: Date;
    onDateUpdated: (date: Date) => void;
    calendarIds: string[];
}

const WeeklyDayPickerCommonStyles = {
    dayCell: {
        borderRadius: '2px!important',
    },
    daySelected: {
        selectors: {
            '&, &.ms-CalendarDay-hoverStyle, &.ms-CalendarDay-daySelected': {
                backgroundColor: `${getPalette().themeLight}!important`,
            },
        },
    },
    table: { width: '100%' },
};

export default observer(function MonthView(props: MonthViewProps) {
    const {
        valueTop,
        valueBottom,
        navigatedDate,
        lowerMonthNavigatedDate,
        weeklyDayPickerProps,
        target,
        onCalloutDismiss,
        key,
        isAgendaVisible,
        setIsAgendaVisible,
        onNavigateDate,
        switchToToday,
    } = useMonthViewViewState(props);

    const tzToday = asDate(observableToday());

    return (
        <div className={styles.monthContainer}>
            <ExpandableDatePicker
                selectedDate={navigatedDate}
                onSelectDate={onNavigateDate}
                numDaysInDayView={1}
                viewType={CalendarViewType.Month}
                showNavigation={true}
                onSelectToday={switchToToday}
            />
            <WeeklyDayPicker
                key={key}
                className={styles.weeklyDayPicker}
                dateTimeFormatter={dateTimeFormatter}
                styles={{
                    ...WeeklyDayPickerCommonStyles,
                    navigationIconButton: { display: 'none' },
                }}
                strings={getCalendarStrings()}
                today={tzToday}
                initialDate={valueTop ? valueTop : undefined}
                navigatedDate={navigatedDate}
                showFullMonth={true}
                onNavigateDate={onNavigateDate}
                animationDirection={AnimationDirection.Vertical}
                {...weeklyDayPickerProps.top}
            />
            <ExpandableDatePicker
                selectedDate={lowerMonthNavigatedDate}
                onSelectDate={props.onDateUpdated}
                numDaysInDayView={1}
                viewType={CalendarViewType.Month}
                showNavigation={false}
                onSelectToday={switchToToday}
            />
            <WeeklyDayPicker
                className={classNames(styles.weeklyDayPicker, styles.bottomWeeklyDayPicker)}
                styles={{
                    ...WeeklyDayPickerCommonStyles,
                    navigationIconButton: { display: 'none' },
                    weekDayLabelCell: { display: 'none' },
                }}
                dateTimeFormatter={dateTimeFormatter}
                strings={getCalendarStrings()}
                today={tzToday}
                initialDate={valueBottom ? valueBottom : undefined}
                navigatedDate={lowerMonthNavigatedDate}
                showFullMonth={true}
                onNavigateDate={onNavigateDate}
                animationDirection={AnimationDirection.Vertical}
                {...weeklyDayPickerProps.bottom}
            />
            <MonthViewDayAgendaCallout
                date={valueTop ? valueTop : valueBottom}
                target={target!}
                onCalloutDismiss={onCalloutDismiss}
                isAgendaVisible={isAgendaVisible}
                setIsAgendaVisible={setIsAgendaVisible}
                {...props}
            />
        </div>
    );
});
